import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HeaderItem } from './header';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private headerConfigSource = new Subject<any>();
  headerConfig$ = this.headerConfigSource.asObservable();

  constructor() { }

  configureHeaderItems(headerItems: HeaderItem) {
    this.headerConfigSource.next(headerItems);
  }
}
